export default __webpack_public_path__ + "../staticImages/kaese_schinken-260.png";